
const config = {
  
    //    API_URL: 'http://localhost/regs-lnwf-webapp/',
    //  API_URL: 'https://10.22.51.190/regs-lnwf-webapp/',
    API_URL: 'https://ln15.gsb.or.th/regs-lnwf-webapp/'

  
 
}


module.exports = {


    config: config
};

